<template>
    <label class="inline-flex items-center text-gray-600 dark:text-gray-400">
        <input type="radio" :disabled="disabled" :name="name" :value="value" v-model="proxyChecked"
               :style="{ 'opacity': disabled ? 0.5 : 1 }"
               class="text-dark form-radio focus:border-darkh focus:outline-none focus:shadow-outline-white">
        <span class="ml-2"><slot></slot></span>
    </label>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ['update:checked'],

    props: {
        checked: {
            type: [Number, String, Boolean],
            default: false,
        },
        value: {
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
})
</script>
